export default {"src":"/_next/static/media/cart.e23ef551.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};